<template>
  <v-app class="client-feedback-form-page" transition="fade-transition">
    <v-card tile transition="fade-transition">
      <v-container fluid>
        <v-progress-linear v-if="formLoading" indeterminate color="secondary" />
        <v-alert v-if="formError" type="error">{{ formError }}</v-alert>
        <v-alert v-if="complete" type="success">Thank you. Your feedback has been submitted.</v-alert>
        <v-form v-if="feedbackReady && !complete" ref="feedbackform" v-model="valid" lazy-validation>
        <v-layout wrap justify-center mb-2>
          <v-flex xs12 md7 class="content">
            <v-row class="mb-4">
              <v-col cols="12" class="text-center">
                <div class="avatar-logo">
                  <img :src="logoDataUrl" alt="Logo" />
                </div>
                <h2 class="form-title">Kobe Feedback Form</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.account_manager.title}}</p>
                <p>{{amFullName}}</p>
              </v-col>
              <v-col cols="6">
                <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.client_name.title}}</p>
                <p>{{clientName}}</p>
              </v-col>
              <v-col cols="6">
                <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.content_curator.title}}</p>
                <p>{{coFullName}}</p>
              </v-col>
              <v-col cols="6">
                <p class="h4 font-weight-bold mb-2">Campaign Name</p>
                <p>{{campaign_name}}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p class="subtitle-1 font-weight-bold mb-0">Your feedback helps decide what improvements should be made and what new features to work on in the future.</p>
                <p class="subtitle-1 mb-0">We would like to take this opportunity to find out your experience working with Kobe.</p>
                <p class="subtitle-1 mb-0">This form will take you 5 minutes to complete.</p>
                <p class="subtitle-1 mb-0">Thank you for your time.</p>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col>
                <p class="h4 font-weight-bold mb-0">{{feedbackFormSections.campaign_name.title}} <span class="red--text" v-show="feedbackFormSections.campaign_name.required">*</span></p>
                <v-text-field
                  class="font-weight-bold"
                  value="XS Trading"
                  v-model="campaign_name"
                  :error-messages="$v.campaign_name.$error && feedbackFormSections.campaign_name.title+' is required.'"
                  @input="$v.campaign_name.$touch()"
                  required
                  disabled
                ></v-text-field>
              </v-col>
            </v-row> -->

            <v-row>
              <v-col>
                <v-data-table :headers="feedbackFormSections.good_ratings.headers"
                :items="feedbackFormSections.good_ratings.fields"
                hide-default-footer
                disable-sort="true"
                class="rate-data-table elevation-0">
                  <template v-slot:body="props">
                    <tbody>
                      <tr v-for="(item, index) in props.items" :key="index" :class="{'bg--white': !item.selected, 'bg-soft-grey': item.selected}">
                        <td class="d-block d-sm-table-cell text-xs-left">
                          <p class="mb-0 pt-xs-5 pb-2">{{ item.title }} <span class="red--text" v-show="item.required">*</span></p>
                          <v-fade-transition>
                            <v-alert
                              class="td-error rounded-0"
                              dense
                              v-show="$v.feedback[item.name].$error"
                              color="red"
                            >
                              {{item.title}} Required.
                            </v-alert>
                          </v-fade-transition>
                        </td>
                        <td class="d-block d-sm-table-cell" v-for="(v, vindex) in feedbackFormSections.good_ratings.values" :key="vindex">
                          <v-radio-group v-model="feedback[item.name]" @change="changeSelected" required>
                            <v-layout wrap>
                              <v-flex xs1 md12>
                                <v-radio :value="v" color="secondary" class="justify-center float-xs-left"></v-radio>
                              </v-flex>
                              <v-flex xs11 md6>
                                <span class="d-md-none d-lg-none d-xl-none d-sm-none pl-2">{{v}}</span>
                              </v-flex>
                            </v-layout>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <!-- <v-row class="mb-4">
              <v-col>
                <v-data-table :headers="feedbackFormSections.satisfy_ratings.headers"
                :items="feedbackFormSections.satisfy_ratings.fields"
                hide-default-footer
                disable-sort="true"
                class="rate-data-table elevation-0">
                  <template v-slot:body="props">
                    <tbody>
                      <tr v-for="(item, index) in props.items" :key="index" :class="{'bg--white': !item.selected, 'bg-soft-grey': item.selected}">
                        <td class="d-block d-sm-table-cell no-border text-xs-left">
                          <p class="mb-0 pt-xs-5 pb-2">{{ item.title }} <span class="red--text" v-show="item.required">*</span></p>
                          <v-fade-transition>
                            <v-alert
                              class="td-error rounded-0"
                              dense
                              v-show="$v.feedback[item.name].$error"
                              color="red"
                            >
                              {{item.title}} Required.
                            </v-alert>
                          </v-fade-transition>
                        </td>
                        <td class="d-block d-sm-table-cell no-border" v-for="(v, vindex) in feedbackFormSections.satisfy_ratings.values" :key="vindex">
                          <v-radio-group v-model="feedback[item.name]" @change="changeSelected" required>
                            <v-layout wrap>
                              <v-flex xs1 md12>
                                <v-radio :value="v" color="secondary" class="justify-center float-xs-left"></v-radio>
                              </v-flex>
                              <v-flex xs11 md6>
                                <span class="d-md-none d-lg-none d-xl-none d-sm-none pl-2">{{v}}</span>
                              </v-flex>
                            </v-layout>
                          </v-radio-group>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row> -->

            <!-- <v-row>
              <v-col>
                <p class="h4 font-weight-bold mb-0 pb-5">{{feedbackFormSections.services_appeals.title}} <span class="red--text" v-show="feedbackFormSections.services_appeals.required">*</span></p>
                <v-layout wrap justify-center mb-2>
                  <v-flex xs12 md4 v-for="sv in feedbackFormSections.services_appeals.fields" :key="sv.key">
                    <v-checkbox
                      v-model="feedback[feedbackFormSections.services_appeals.name]"
                      :label="sv.label"
                      :value="sv.value"
                      :error="$v.feedback[feedbackFormSections.services_appeals.name].$error"
                      color="secondary"
                      class="mt-0"
                      required
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-fade-transition>
                      <v-alert
                        class="alert-error rounded-0"
                        dense
                        v-show="$v.feedback[feedbackFormSections.services_appeals.name].$error"
                        color="red"
                      >
                        {{feedbackFormSections.services_appeals.title}} Required.
                      </v-alert>
                    </v-fade-transition>
                  </v-flex>

                </v-layout>
              </v-col>
            </v-row> -->

            <v-row class="mb-4">
              <v-col>
                <v-data-table
                :items="feedbackFormSections.likely_recommend.fields"
                hide-default-header
                hide-default-footer
                disable-sort="true"
                class="rate-data-table elevation-0">
                  <template v-slot:body="props">
                    <tbody>
                      <tr v-for="(item, index) in props.items" :key="index" :class="{'bg--white': !item.selected, 'bg-soft-grey': item.selected}">
                        <td class="d-block d-sm-table-cell no-border text-xs-left">
                            <p class="mb-0 pt-5">{{item.title}} <span class="red--text" v-if="item.required">*</span></p>
                            <p class="caption mb-xs-0">{{item.caption}}</p>
                            <v-fade-transition>
                              <v-alert
                                class="td-error rounded-0"
                                dense
                                v-show="$v.feedback[item.name].$error"
                                color="red"
                              >
                                {{item.title}} Required.
                              </v-alert>
                            </v-fade-transition>
                        </td>
                        <td class="d-block d-sm-table-cell no-border pa-5">
                          <v-rating
                            v-model="feedback[item.name]"
                            length="10"
                            color="secondary"
                            background-color="grey lighten-1"
                            :size="starSize"
                            class="rating-icon float-md-right"
                            dense
                            hover
                          >
                            <template v-slot:item="props">
                              <v-icon
                                class="rating-icon"
                                large
                                :color="props.isFilled ? 'secondary' : ''"
                                v-text="`mdi-numeric-${props.index + 1}-box`"
                                @click="props.click"
                              ></v-icon>
                            </template>
                          </v-rating>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col>
                <v-data-table
                :items="feedbackFormSections.likely_consider_again.fields"
                hide-default-header
                hide-default-footer
                disable-sort="true"
                class="rate-data-table elevation-0">
                  <template v-slot:body="props">
                    <tbody>
                      <tr v-for="(item, index) in props.items" :key="index" :class="{'bg--white': !item.selected, 'bg-soft-grey': item.selected}">
                        <td class="d-block d-sm-table-cell no-border text-xs-left">
                            <p class="mb-0 pt-xs-5">{{item.title}} <span class="red--text" v-if="item.required">*</span></p>
                            <p class="caption mb-xs-0">{{item.caption}}</p>
                            <v-fade-transition>
                              <v-alert
                                class="td-error rounded-0"
                                dense
                                v-show="$v.feedback[item.name].$error"
                                color="red"
                              >
                                {{item.title}} Required.
                              </v-alert>
                            </v-fade-transition>
                        </td>
                        <td class="d-block d-sm-table-cell no-border pa-5">
                          <v-rating
                            v-model="feedback[item.name]"
                            length="10"
                            color="secondary"
                            background-color="grey lighten-1"
                            :size="starSize"
                            class="float-md-right"
                            dense
                            hover
                          >
                            <template v-slot:item="props">
                              <v-icon
                                class="rating-icon"
                                large
                                :color="props.isFilled ? 'secondary' : ''"
                                v-text="`mdi-numeric-${props.index + 1}-box`"
                                @click="props.click"
                              ></v-icon>
                            </template>
                          </v-rating>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col>
                <p class="h4 font-weight-bold mb-5">{{feedbackFormSections.buyagain_decision.title}} <span class="red--text" v-if="feedbackFormSections.buyagain_decision.required">*</span></p>
                <v-layout wrap>
                  <v-flex xs12 md6 v-for="b in feedbackFormSections.buyagain_decision.fields" :key="b.key">
                    <v-checkbox
                      v-model="feedback[feedbackFormSections.buyagain_decision.name]"
                      :label="b.label"
                      :value="b.value"
                      :error="$v.feedback[feedbackFormSections.buyagain_decision.name].$error"
                      v-if="b.type=='checkbox'"
                      color="secondary"
                      class="mt-0"
                    ></v-checkbox>

                    <v-text-field
                      v-model="other_buyagain_decisions"
                      :label="b.label"
                      v-if="b.type=='textfield'"
                      outlined
                      dense
                      class="v-text-field-sm mt-0"
                      :error="$v.other_buyagain_decisions.$error"
                      @input="$v.other_buyagain_decisions.$touch()"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-fade-transition>
                      <v-chip
                        class="checkboxes-error rounded-0 float-md-left"
                        color="red"
                        text-color="white"
                        small
                        v-if="$v.feedback[feedbackFormSections.buyagain_decision.name].$error || $v.other_buyagain_decisions.$error"
                      >
                        {{feedbackFormSections.buyagain_decision.title}} Required.
                      </v-chip>
                    </v-fade-transition>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.what_did_well.title}} <span class="red--text" v-if="feedbackFormSections.what_did_well.required">*</span></p>
                <v-textarea
                  v-model="feedback[feedbackFormSections.what_did_well.name]"
                  outlined
                  :error-messages="$v.feedback[feedbackFormSections.what_did_well.name].$error && feedbackFormSections[feedbackFormSections.what_did_well.name].title+' is required.'"
                  @input="$v.feedback[feedbackFormSections.what_did_well.name].$touch()"
                  required
                ></v-textarea>

                <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.what_can_improve.title}} <span class="red--text" v-if="feedbackFormSections.what_can_improve.required">*</span></p>
                <v-textarea
                  v-model="feedback[feedbackFormSections.what_can_improve.name]"
                  outlined
                  :error-messages="$v.feedback[feedbackFormSections.what_can_improve.name].$error && feedbackFormSections.what_can_improve.title+' is required.'"
                  @input="$v.feedback[feedbackFormSections.what_can_improve.name].$touch()"
                  required
                ></v-textarea>

                <!-- <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.what_you_tell_about_kobe.title}} <span class="red--text" v-if="feedbackFormSections.what_you_tell_about_kobe.required">*</span></p>
                <v-textarea
                  v-model="feedback[feedbackFormSections.what_you_tell_about_kobe.name]"
                  :error-messages="$v.feedback[feedbackFormSections.what_you_tell_about_kobe.name].$error && feedbackFormSections.what_you_tell_about_kobe.title+' is required.'"
                  @input="$v.feedback[feedbackFormSections.what_you_tell_about_kobe.name].$touch()"
                  required
                  outlined
                ></v-textarea>

                <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.what_one_word_in_mind_about_kobe.title}} <span class="red--text" v-if="feedbackFormSections.what_one_word_in_mind_about_kobe.required">*</span></p>
                <v-text-field
                  v-model="feedback[feedbackFormSections.what_one_word_in_mind_about_kobe.name]"
                  :error-messages="$v.feedback[feedbackFormSections.what_one_word_in_mind_about_kobe.name].$error && feedbackFormSections.what_one_word_in_mind_about_kobe.title+' is required.'"
                  @input="$v.feedback[feedbackFormSections.what_one_word_in_mind_about_kobe.name].$touch()"
                  required
                  outlined
                ></v-text-field> -->
              </v-col>
            </v-row>

            <!-- <v-row class="mb-4">
              <v-col xs12 md12>
                <v-layout wrap>
                  <v-flex class="mb-5" xs12 md12 v-for="(kobe, index) in feedbackFormSections.kobe_improve_on.fields" :key="index">
                    <div>
                      <p class="h4 font-weight-bold mb-0">{{kobe.label}} <span class="red--text" v-if="kobe.required">*</span></p>
                      <div v-if="kobe.type === 'radio'">
                        <v-radio-group v-model="feedback[kobe.name]" required row>
                          <v-radio :value="v" :label="v" color="secondary" class="justify-center" v-for="(v, vindex) in feedbackFormSections.kobe_improve_on.values" :key="vindex"></v-radio>
                        </v-radio-group>
                        <v-fade-transition>
                          <v-chip
                            class="rounded-0"
                            style="margin-top: -30px;"
                            color="red"
                            text-color="white"
                            small
                            v-show="$v.feedback[kobe.name].$error"
                          >
                          {{kobe.label}} Required.
                          </v-chip>
                        </v-fade-transition>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row> -->

            <v-row class="mb-4">
              <v-col>
                <p class="h4 font-weight-bold mb-0">{{feedbackFormSections.account_manager_status.rate_title}}</p>
                <p class="h4 mb-5" style="font-size: 15px">{{feedbackFormSections.account_manager_status.rate_desc}}</p>
                <p class="h4 font-weight-bold mb-3">{{feedbackFormSections.account_manager_status.title}} {{amFullName}}, is</p>
                <v-layout class="pl-5" wrap>
                  <v-flex xs12 md12 class="mb-3" v-for="b in feedbackFormSections.account_manager_status.fields" :key="b.key">
                    <p class="h4 font-weight-bold mb-1">{{b.label}}</p>
                    <p class="caption mb-2" v-show="b.caption">{{b.caption}}</p>
                    <v-rating
                      v-model="feedback[b.name]"
                      length="4"
                      color="secondary"
                      background-color="grey lighten-1"
                      :size="starSize"
                      class="float-md-left"
                      dense
                      hover
                    >
                      <template v-slot:item="props">
                        <v-icon
                          class="rating-icon"
                          large
                          :color="props.isFilled ? 'secondary' : ''"
                          v-text="`mdi-numeric-${props.index + 1}-box`"
                          @click="props.click"
                        ></v-icon>
                      </template>
                    </v-rating>
                  </v-flex>
                  <!-- <v-flex xs12 md12>
                    <v-fade-transition>
                      <v-chip
                        class="checkboxes-error rounded-0 float-md-left"
                        color="red"
                        text-color="white"
                        small
                        v-if="$v.feedback[feedbackFormSections.buyagain_decision.name].$error || $v.other_buyagain_decisions.$error"
                      >
                        {{feedbackFormSections.buyagain_decision.title}} Required.
                      </v-chip>
                    </v-fade-transition>
                  </v-flex> -->
                </v-layout>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col xs12 md12>
                <v-layout wrap>
                  <v-flex class="mb-5" xs12 md12 v-for="(lineup, index) in feedbackFormSections.inf_line_up.fields" :key="index">
                    <div>
                      <p class="h4 font-weight-bold mb-0">{{lineup.label}} <span class="red--text" v-if="lineup.required">*</span></p>
                      <p class="caption mb-2" v-show="lineup.caption">{{lineup.caption}}</p>
                      <div v-if="lineup.type === 'radio'">
                        <v-radio-group v-model="feedback[lineup.name]" required column>
                          <v-radio :value="v" :label="v" color="secondary" class="justify-center" v-for="(v, vindex) in feedbackFormSections.inf_line_up.values" :key="vindex"></v-radio>
                        </v-radio-group>
                        <v-fade-transition>
                          <v-chip
                            class="rounded-0"
                            style="margin-top: -30px;"
                            color="red"
                            text-color="white"
                            small
                            v-show="$v.feedback[lineup.name].$error"
                          >
                          {{lineup.label}} Required.
                          </v-chip>
                        </v-fade-transition>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <!-- <v-row class="mb-4">
              <v-col xs12 md12>
                <v-layout wrap>
                  <v-flex class="mb-5" xs12 md12 v-for="(lineup, index) in feedbackFormSections.inf_line_up.fields" :key="index">
                    <div>
                      <p class="h4 font-weight-bold mb-0">{{lineup.label}} <span class="red--text" v-if="lineup.required">*</span></p>
                      <p class="caption mb-2" v-show="lineup.caption">{{lineup.caption}}</p>
                      <div v-if="lineup.type === 'radio'">
                        <v-radio-group v-model="feedback[lineup.name]" required column>
                          <v-radio :value="v" :label="v" color="secondary" class="justify-center" v-for="(v, vindex) in feedbackFormSections.inf_line_up.values" :key="vindex"></v-radio>
                        </v-radio-group>
                        <v-fade-transition>
                          <v-chip
                            class="rounded-0"
                            style="margin-top: -30px;"
                            color="red"
                            text-color="white"
                            small
                            v-show="$v.feedback[lineup.name].$error"
                          >
                          {{lineup.label}} Required.
                          </v-chip>
                        </v-fade-transition>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row> -->

            <v-row class="mb-4">
              <v-col xs12 md12>
                <v-layout wrap>
                  <v-flex class="mb-5" xs12 md12 v-for="(contentCreated, index) in feedbackFormSections.inf_content_created.fields" :key="index">
                    <div>
                      <p class="h4 font-weight-bold mb-0">{{contentCreated.label}} <span class="red--text" v-if="contentCreated.required">*</span></p>
                      <p class="caption mb-2" v-show="contentCreated.caption">{{contentCreated.caption}}</p>
                      <div v-if="contentCreated.type === 'radio'">
                        <v-radio-group v-model="feedback[contentCreated.name]" required column>
                          <v-radio :value="v" :label="v" color="secondary" class="justify-center" v-for="(v, vindex) in feedbackFormSections.inf_content_created.values" :key="vindex"></v-radio>
                        </v-radio-group>
                        <v-fade-transition>
                          <v-chip
                            class="rounded-0"
                            style="margin-top: -30px;"
                            color="red"
                            text-color="white"
                            small
                            v-show="$v.feedback[contentCreated.name].$error"
                          >
                          {{contentCreated.label}} Required.
                          </v-chip>
                        </v-fade-transition>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <!-- <v-row class="mb-4">
              <v-col>
                <p class="h4 font-weight-bold mb-2">{{feedbackFormSections.kobe_connect.title}}</p>
                <div v-for="(k, index) in feedbackFormSections.kobe_connect.fields" :key="index">
                  <v-text-field
                    :label="k.label"
                    :placeholder="k.placeholder"
                    v-model="feedback[k.name]"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row> -->

            <!-- <v-row class="mb-4">
              <v-col>
                <p class="h4 font-weight-bold mb-5">{{feedbackFormSections.marketing_challenges.title}} <span class="red--text" v-if="feedbackFormSections.marketing_challenges.required">*</span></p>
                <v-layout wrap>
                  <v-flex xs12 md6 v-for="m in feedbackFormSections.marketing_challenges.fields" :key="m.key">
                    <v-checkbox
                      v-model="feedback[feedbackFormSections.marketing_challenges.name]"
                      :label="m.label"
                      :value="m.value"
                      :error="$v.feedback[feedbackFormSections.marketing_challenges.name].$error"
                      v-if="m.type=='checkbox'"
                      class="mt-0"
                    ></v-checkbox>

                    <v-text-field
                      v-model="other_marketing_challenges"
                      :label="m.label"
                      :value="m.value"
                      v-if="m.type=='textfield'"
                      outlined
                      dense
                      class="v-text-field-sm mt-0"
                      :error="$v.other_marketing_challenges.$error"
                      @input="$v.other_marketing_challenges.$touch()"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-fade-transition>
                      <v-chip
                        class="checkboxes-error rounded-0 float-md-left"
                        color="red"
                        text-color="white"
                        small
                        v-if="$v.feedback.marketing_challenges.$error || $v.other_marketing_challenges.$error"
                      >
                        {{feedbackFormSections.marketing_challenges.title}} Required.
                      </v-chip>
                    </v-fade-transition>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row> -->

            <v-row class="mb-4">
              <v-col>
                <p class="h4 font-weight-bold mb-5">{{feedbackFormSections.sea_countries.title}} <span class="red--text" v-if="feedbackFormSections.sea_countries.required">*</span></p>
                <v-layout wrap>
                  <v-flex xs12 md6 v-for="b in feedbackFormSections.sea_countries.fields" :key="b.key">
                    <v-checkbox
                      v-model="feedback[feedbackFormSections.sea_countries.name]"
                      :label="b.label"
                      :value="b.value"
                      :error="$v.feedback[feedbackFormSections.sea_countries.name].$error"
                      v-if="b.type=='checkbox'"
                      color="secondary"
                      class="mt-0"
                    ></v-checkbox>

                    <v-text-field
                      v-model="other_sea_countries"
                      :label="b.label"
                      v-if="b.type=='textfield'"
                      outlined
                      dense
                      class="v-text-field-sm mt-0"
                      :error="$v.other_sea_countries.$error"
                      @input="$v.other_sea_countries.$touch()"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-fade-transition>
                      <v-chip
                        class="checkboxes-error rounded-0 float-md-left"
                        color="red"
                        text-color="white"
                        small
                        v-if="$v.feedback[feedbackFormSections.sea_countries.name].$error || $v.other_sea_countries.$error"
                      >
                        {{feedbackFormSections.sea_countries.title}} Required.
                      </v-chip>
                    </v-fade-transition>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col>
                <p class="h4 font-weight-bold mb-5">{{feedbackFormSections.platforms.title}} <span class="red--text" v-if="feedbackFormSections.platforms.required">*</span></p>
                <v-layout wrap>
                  <v-flex xs12 md6 v-for="b in feedbackFormSections.platforms.fields" :key="b.key">
                    <v-checkbox
                      v-model="feedback[feedbackFormSections.platforms.name]"
                      :label="b.label"
                      :value="b.value"
                      :error="$v.feedback[feedbackFormSections.platforms.name].$error"
                      v-if="b.type=='checkbox'"
                      color="secondary"
                      class="mt-0"
                    ></v-checkbox>

                    <v-text-field
                      v-model="other_platforms"
                      :label="b.label"
                      v-if="b.type=='textfield'"
                      outlined
                      dense
                      class="v-text-field-sm mt-0"
                      :error="$v.other_platforms.$error"
                      @input="$v.other_platforms.$touch()"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-fade-transition>
                      <v-chip
                        class="checkboxes-error rounded-0 float-md-left"
                        color="red"
                        text-color="white"
                        small
                        v-if="$v.feedback[feedbackFormSections.platforms.name].$error || $v.other_platforms.$error"
                      >
                        {{feedbackFormSections.platforms.title}} Required.
                      </v-chip>
                    </v-fade-transition>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col xs12 md12>
                <v-layout wrap>
                  <v-flex class="mb-3" xs12 md12 v-for="(kobe, index) in feedbackFormSections.kobe_questions.fields" :key="index">
                    <div v-if="kobe.name !== 'open_sharing_feedback'">
                      <p class="h4 font-weight-bold mb-0">{{kobe.label}} <span class="red--text" v-if="kobe.required">*</span></p>
                      <div v-if="kobe.type === 'radio'">
                        <v-radio-group v-model="feedback[kobe.name]" required row>
                          <v-radio :value="v" :label="v" color="secondary" class="justify-center" v-for="(v, vindex) in feedbackFormSections.kobe_questions.values" :key="vindex"></v-radio>
                        </v-radio-group>
                        <v-fade-transition>
                          <v-chip
                            class="rounded-0"
                            style="margin-top: -30px;"
                            color="red"
                            text-color="white"
                            small
                            v-show="$v.feedback[kobe.name].$error"
                          >
                          {{kobe.label}} Required.
                          </v-chip>
                        </v-fade-transition>
                      </div>
                      <div class="mt-3" v-if="kobe.type === 'textarea'">
                        <v-textarea
                          v-model="feedback[kobe.name]"
                          outlined
                          :error-messages="$v.feedback[kobe.name].$error && kobe.label+' Required.'"
                          @input="$v.feedback[kobe.name].$touch()"
                          required
                        ></v-textarea>
                      </div>
                      <p class="caption" v-show="kobe.caption">{{kobe.caption}}</p>
                    </div>
                  </v-flex>
                  <v-flex class="mb-2" xs12 md12>                    
                    <v-row>
                      <v-col>
                        <p class="h4 font-weight-bold mb-3">{{feedbackFormSections.refer_info.title}} <span class="red--text">*</span></p>
                        <v-layout wrap>
                          <v-flex xs12 md6 v-for="(contact, index) in feedbackFormSections.refer_info.fields" :key="index">
                            <div>
                              <!-- <p class="h4 font-weight-bold mb-2">{{contact.label}} <span class="red--text" v-if="contact.required">*</span></p> -->
                              <v-text-field
                                :label="contact.label"
                                v-model="feedback[contact.name]"
                                outlined
                                dense
                                :class="contact.class? contact.class+' mt-0': 'mt-0'"
                                :error-messages="$v.feedback[contact.name].$error && `${contact.label} is required.`"
                                @input="$v.feedback[contact.name].$touch()"
                                required
                              ></v-text-field>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-flex>
                  <v-flex class="mb-2" xs12 md12>
                    <div>
                      <v-checkbox
                        class="schedule-sharing-chk mt-0"
                        v-model="feedback.scheduleSharing"
                        label="I would like for Kobe to schedule an internal sharing for the rest of my business teams"
                        :value="false"
                        color="secondary"
                      ></v-checkbox>
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-layout wrap>
                  <v-flex xs12 md6 v-for="(contact, index) in feedbackFormSections.contact_info.fields" :key="index">
                    <div>
                      <p class="h4 font-weight-bold mb-2">{{contact.label}} <span class="red--text" v-if="contact.required">*</span></p>
                      <v-text-field
                        v-model="feedback[contact.name]"
                        outlined
                        dense
                        :class="contact.class? contact.class+' mt-0': 'mt-0'"
                        :error-messages="$v.feedback[contact.name].$error && `${contact.label} is required.`"
                        @input="$v.feedback[contact.name].$touch()"
                        required
                      ></v-text-field>
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitFeedback">
                  <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                  Submit
                </v-btn>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col>

              </v-col>
            </v-row> -->

          </v-flex>
        </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </v-app>
</template>
<script>
import clientConfig from './clientConfig.js';
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import campaignAPIs from '../Campaign/campaignAPIs'
import logoDataURL from '@/config/logoDataURL'
import { createSubmissionID } from '@/utils/submissionID'
export default {
  name: 'CreateFeedbacksForm',
  mixins: [validationMixin],
  validations: function() {
    const validationRules = {
      // campaign_name: this.feedbackFormSections.campaign_name.required ? {required} : {},
      feedback: {
        // [this.feedbackFormSections.services_appeals.name]: this.feedbackFormSections.services_appeals.required ? {required} : {},
        [this.feedbackFormSections.what_did_well.name]: {required},
        [this.feedbackFormSections.what_can_improve.name]: {required},
        // [this.feedbackFormSections.what_you_tell_about_kobe.name]: {required},
        // [this.feedbackFormSections.what_one_word_in_mind_about_kobe.name]: {required},
        [this.feedbackFormSections.buyagain_decision.name]: this.feedbackFormSections.buyagain_decision.required ? { // if no buy decisions, check if other buy decisions exist
          required: requiredIf(function() {
            return !this.other_buyagain_decisions;
          })
        } : {},
        [this.feedbackFormSections.sea_countries.name]: this.feedbackFormSections.sea_countries.required ? { // if no sea countries, check if other sea countries exist
          required: requiredIf(function() {
            return !this.other_sea_countries;
          })
        } : {},
        [this.feedbackFormSections.platforms.name]: this.feedbackFormSections.platforms.required ? { // if no platforms, check if other platforms exist
          required: requiredIf(function() {
            return !this.other_platforms;
          })
        } : {}
        // [this.feedbackFormSections.marketing_challenges.name]: this.feedbackFormSections.marketing_challenges.required ? {
        //   required: requiredIf(function() {
        //     return !this.other_marketing_challenges;
        //   })
        // } : {}
      },
      other_buyagain_decisions: this.feedbackFormSections.buyagain_decision.required ? { // if no other buy decisions, check if buy decisions exist
        required: requiredIf(function() {
          return !this.feedback.buyagain_decisions.length;
        })
      } : {},
      other_sea_countries: this.feedbackFormSections.sea_countries.required ? { // if no other sea countries, check if sea countries exist
        required: requiredIf(function() {
          return !this.feedback.sea_countries.length;
        })
      } : {},
      other_platforms: this.feedbackFormSections.platforms.required ? { // if no other platforms, check if platforms exist
        required: requiredIf(function() {
          return !this.feedback.platforms.length;
        })
      } : {}
      // other_marketing_challenges: this.feedbackFormSections.marketing_challenges.required ? {
      //   required: requiredIf(function() {
      //     return !this.feedback.marketing_challenges.length;
      //   })
      // } : {}
    };

    let multiplevalidations = [
      'good_ratings',
      // 'satisfy_ratings',
      'likely_recommend',
      'likely_consider_again',
      // 'kobe_improve_on',
      'inf_line_up',
      'inf_content_created',
      'kobe_questions',
      'refer_info',
      'contact_info'
    ];

    multiplevalidations.map(val => {
      this.feedbackFormSections[val].fields.forEach(field => {
        let addRule = false
        if (val === 'kobe_questions') {
          addRule = field.name !== 'open_sharing_feedback'
        } else addRule = true
        if (addRule) validationRules['feedback'][field.name] = {required};
      })
    })
    return validationRules
  },
  data () {
    return {
      formLoading: true,
      formError: '',
      feedbackReady: false,
      complete: false,
      dialog: true,
      submitting: false,
      valid: true,
      campaignID: '',
      campaign_name: '',
      amID: '',
      amFirstName: '',
      amLastName: '',
      amFullName: '',
      amEmail: '',
      coID: '',
      coFullName: '',
      clientID: '',
      clientName: '',
      feedbackFormSections: clientConfig.feedbackFormSections,
      feedback: {
        // marketing_challenges: [],
        buyagain_decisions: [],
        sea_countries: [],
        platforms: [],
        scheduleSharing: false
        // services_appeals: []
      },
      submissionID: createSubmissionID(),
      other_buyagain_decisions: '',
      other_sea_countries: '',
      other_platforms: '',
      logoDataUrl: logoDataURL.logo || '/static/img/kobe_bg_main.png'
      // other_marketing_challenges: ''
    }
  },
  watch: {
    other_buyagain_decisions: {
      handler(newValue, oldValue) {
        let index = this.feedback.buyagain_decisions.indexOf(oldValue)
        if (index === -1) {
          this.feedback.buyagain_decisions.push(newValue)
        } else {
          this.feedback.buyagain_decisions[index] = newValue
        }
        this.feedback.buyagain_decisions = this.feedback.buyagain_decisions.filter(function (el) { return el !== ''; });
      }
    },
    other_sea_countries: {
      handler(newValue, oldValue) {
        let index = this.feedback.sea_countries.indexOf(oldValue)
        if (index === -1) {
          this.feedback.sea_countries.push(newValue)
        } else {
          this.feedback.sea_countries[index] = newValue
        }
        this.feedback.sea_countries = this.feedback.sea_countries.filter(function (el) { return el !== ''; });
      }
    },
    other_platforms: {
      handler(newValue, oldValue) {
        let index = this.feedback.platforms.indexOf(oldValue)
        if (index === -1) {
          this.feedback.platforms.push(newValue)
        } else {
          this.feedback.platforms[index] = newValue
        }
        this.feedback.platforms = this.feedback.platforms.filter(function (el) { return el !== ''; });
      }
    }
    // other_marketing_challenges: {
    //   handler(newValue, oldValue) {
    //     let index = this.feedback.marketing_challenges.indexOf(oldValue)
    //     if (index === -1) {
    //       this.feedback.marketing_challenges.push(newValue)
    //     } else {
    //       this.feedback.marketing_challenges[index] = newValue
    //     }
    //     this.feedback.marketing_challenges = this.feedback.marketing_challenges.filter(function (el) { return el !== ''; });
    //   }
    // }
  },
  computed: {
    starSize: function() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 28
        case 'sm': return 30
        case 'md': return 30
        case 'lg': return 30
        case 'xl': return 30
      }
    }
  },
  methods: {
    close() {
      this.$router.push({path: '/client'})
    },
    submitFeedback() {
      if (this.submitting || this.complete || !this.feedbackReady) return
      this.$v.$touch()
      if (this.$v.feedback.$error) {
        return false
      }
      this.submitting = true;
      const feedback = { ...this.feedback };
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          let formData = new FormData();
          formData.append('feedback', JSON.stringify(feedback));
          formData.append('campaignID', this.campaignID);
          formData.append('token', new URLSearchParams(this.$route.hash.slice(1)).get('token') || '');
          formData.append('submissionID', this.submissionID);
          campaignAPIs
            .createClientFeedback(formData)
            .then(response => {
              // Dismiss modal by triggering the click event on Close button
              // this.close();
              setTimeout(() => {
                // Update submitting status
                this.submitting = false;
              }, 2000)
              this.complete = true;
            })
            .catch(error => {
              // Update submitting status
              setTimeout(() => {
                this.submitting = false;
              }, 2000)
              // Request failed.
              console.log('error', error);
              this.$swal({
                text: (error.response && error.response.data && error.response.data.message) || 'Unable to submit feedback. Your answers have been kept.',
                type: 'error'
              });
            });
        } else {
          setTimeout(() => {
            // Update submitting status
            this.submitting = false;
          }, 1000)
        }
      });
    }
  },
  mounted() {
    this.campaignID = this.$route.params.campaignId;
    campaignAPIs
    .getCampaignDetailForFeedbackInvitation(this.campaignID, new URLSearchParams(this.$route.hash.slice(1)).get('token') || '')
    .then(async (response) => {
      if (!response.id) throw new Error('Invalid feedback link.');
      this.campaignID = response.id
      this.campaign_name = response.name
      this.amID = response.am.id
      this.amFirstName = response.am.firstName
      this.amFirstName = response.am.lastName
      this.amFullName = `${response.am.firstName} ${response.am.lastName}`
      this.amEmail = response.am.email
      this.coID = response.co.id
      this.coFullName = `${response.co.firstName} ${response.co.lastName}`
      this.clientID = response.client.id
      this.clientName = response.client.name
      this.feedbackReady = true
    })
    .catch(error => {
      this.formError = (error.response && error.response.data && error.response.data.message) || 'This feedback link is unavailable. Please request a new link from your account manager.';
    })
    .finally(() => { this.formLoading = false })
  }
}
</script>
<style lang="scss">
  .v-dialog--fullscreen {
    scroll-behavior: smooth;
  }
</style>
<style scoped>
  .client-feedback-form-page {
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .bg-soft-grey {
    background-color: #f6f6f6;
  }

  .bg--white {
    background-color: #fff;
  }

  .v-text-field-sm{
    width: 320px;
  }

  /* .td-error {
    margin-bottom: -20px;
    right: 16px;
  } */

  .td-error, .alert-error {
    display: inline-block;
    font-size: 12px;
    right: 15px;
    padding: 5px;
    margin-bottom: 0px;
    color: #fff!important;
  }

  .alert-error {
    right: 0
  }

  .checkboxes-error {
    margin-top: -15px;
  }

  .d-sm-table-cell {
    height: auto!important;
    padding: 0;
    padding-left: 15px;
  }

  .v-card {
    background-color: rgb(204, 204, 204)!important;
  }

  .content {
    max-width: 100%!important;
    background-color: #fff;
    padding: 50px;
  }

  .avatar-logo {
    margin: 0 auto;
    transition: all 0.5s ease-out;
  }

  .avatar-logo img {
    display: block;
    width: 150px;
    margin: 0 auto;
  }

  .form-title {
    float: none;
    text-align: center;
    font-weight: 600;
    padding: 40px;
    transition: all 0.5s ease-out;
  }

  .rating-icon {
    font-size: 30px!important;
  }

  .rating-selected--text {
    color: var(--v-secondary-base)!important;
  }

  @media (max-width: 768px) {
    .content {
      padding: 20px;
    }
  }

  @media (max-width: 600px) {
    .avatar-logo {
      height: auto!important;
      min-width: 100%!important;
      width: 100%!important;
    }

    .form-title {
      float: none;
      padding: 0;
      font-size: 25px;
      width: 100%;
      text-align: center;
    }

    .float-xs-left {
      float: left;
    }

    .td-error, .alert-error {
      width: 100%;
      right: 0;
    }

    .pt-xs-5 {
      padding-top: 15px
    }

    .mb-xs-0 {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// CreateFeedbacksForm.vue?75f8793d